import { useGetUser } from '@/hooks';
import Loader from '@/ui/Loading/Loader';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function HomePage() {
  const { currentUser, company } = useGetUser();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) {
      navigate('/');
    }
    if (location.pathname === '/') {
      navigate(`/cdk`);
    }
  }, [location.pathname, navigate, currentUser]);

  if (!currentUser && !company) {
    return <Loader />;
  }

  return (
    <div>
      <h1>
        {t('Home.title')} {currentUser.name}
      </h1>
    </div>
  );
}

export default HomePage;
